export default __webpack_public_path__ + "static/media/lathed.038cd406.svg";